import { lenis } from '../global/gsap';

// Reports scroll direction on Lenis event
const onScrollDirection = (callback) => {
    lenis.on('scroll', ({ direction, scroll }) => callback(direction, scroll));
};

export { onScrollDirection as default };
